import { ClaimReservationWithTimeslot } from '@Generated/back-office-client/src'
import { Flex, Text, TextField } from '@radix-ui/themes'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { formatDateComponentsToDayString } from '../util/utils'
import { ArrowLeftIcon, MagnifyingGlassIcon } from '@radix-ui/react-icons'
import { Routes } from '@Components/main-app/types'
import './link-claim-form-popup.scss'

export const LinkClaimFormPopup = ({
  reservation,
  onBack,
}: {
  reservation: ClaimReservationWithTimeslot
  onBack: () => void
}) => {
  const navigate = useNavigate()
  const initialQuery =
    reservation.claimReservationDetails.phone ||
    reservation.claimReservationDetails.email ||
    reservation.claimReservationDetails.name
  const [searchQuery, setSearchQuery] = useState(initialQuery)

  const handleSubmit = () => {
    if (searchQuery.trim()) {
      navigate(
        `${Routes.CLAIM_FORMS}?query=${encodeURIComponent(searchQuery.trim())}&linkReservationId=${reservation.id}`,
      )
    }
  }

  const dateDisplay = formatDateComponentsToDayString(reservation.timeslot.display.dateComponents)
  const timeDisplay = reservation.timeslot.display.localTime

  return (
    <Flex direction="column" gap="4" className="link-claim-form-popup">
      <Text size="2" className="link-claim-form-popup__back" onClick={onBack}>
        <Flex align="center" gap="1">
          <ArrowLeftIcon /> Back
        </Flex>
      </Text>

      <Flex direction="column" gap="2">
        <Text weight="bold" size="5">
          Link Claim Form to Appointment
        </Text>

        <Text size="2" color="gray">
          Locate a player&apos;s claim form and attach it to this appointment on {dateDisplay} at{' '}
          {timeDisplay}.
        </Text>
      </Flex>

      <Flex direction="column" gap="2">
        <Text size="2" weight="bold">
          Name or Phone Number
        </Text>
        <TextField.Root
          placeholder="Search..."
          size="2"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && searchQuery.trim()) {
              handleSubmit()
            }
          }}>
          <TextField.Slot side="right">
            <MagnifyingGlassIcon
              className="link-claim-form-popup__search-icon"
              onClick={() => {
                if (searchQuery.trim()) {
                  handleSubmit()
                }
              }}
            />
          </TextField.Slot>
        </TextField.Root>
      </Flex>
    </Flex>
  )
}
